// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"PreviewTableHeader_visuallyHidden__ScQJj","headerCell":"PreviewTableHeader_headerCell__nz95R"};